import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AiSearchRequest, AiSearchResponse } from '../models/ai-search';

@Injectable({
  providedIn: 'root',
})
export class AiSearchService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiBaseUrl.endsWith('/')
    ? environment.apiBaseUrl.trimEnd()
    : environment.apiBaseUrl;

  search(payload: AiSearchRequest): Observable<AiSearchResponse> {
    return this.http.post<AiSearchResponse>(
      `${this.apiUrl}/api/search-ai/`,
      payload,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
